import { Environment } from './model';

export const environment: Environment = {
  // apiBaseUrl: 'https://api.sportellobalneari.it',
  apiBaseUrl:
    'https://apiservice.wittygrass-0b6a4645.italynorth.azurecontainerapps.io',
  crmApiBaseUrl:
    'https://crmservice.wittygrass-0b6a4645.italynorth.azurecontainerapps.io',
  mapboxAccessToken:
    'pk.eyJ1IjoibHVjYS1iZWxsZWdvbmkiLCJhIjoiY20xdDExMWt0MDBvZjJyczhhdjVleG9vdCJ9.-ovfAZ8hHXe9a30ynpaHWw',
};
